/**
 * @flow
 * @relayHash 1b63b53f1d7a7bd162c13386bfa10a39
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ArticleStateType = "available" | "deleted" | "draft" | "%future added value";
export type ArticleAddInput = {
  title: string,
  slug: string,
  previewPicture?: ?string,
  previewAttribution?: ?string,
  body: string,
  bodyHtml: string,
  lead: string,
  section: string,
  category: string,
  topics?: ?$ReadOnlyArray<?string>,
  linkedArticles?: ?$ReadOnlyArray<?string>,
  author: string,
  hidden?: ?boolean,
  isArticleOfHour?: ?boolean,
  isEvent?: ?boolean,
  isMainNews?: ?boolean,
  infostring?: ?boolean,
  infostring_hot?: ?boolean,
  showInYandexNews?: ?boolean,
  showInYandexZen?: ?boolean,
  yaGenre: string,
  evergreen?: ?boolean,
  availableAt?: ?string,
  seoTitle?: ?string,
  seoDescription?: ?string,
  seoKeywords?: ?string,
  preview?: ?string,
  combinedPreviewVideo?: ?string,
  mediaFiles?: ?$ReadOnlyArray<?string>,
  state: ArticleStateType,
  mainPageOrder: number,
  clientMutationId?: ?string,
};
export type ArticleAddMutationVariables = {|
  input: ArticleAddInput
|};
export type ArticleAddMutationResponse = {|
  +ArticleAdd: ?{|
    +articleEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |}
  |}
|};
export type ArticleAddMutation = {|
  variables: ArticleAddMutationVariables,
  response: ArticleAddMutationResponse,
|};
*/


/*
mutation ArticleAddMutation(
  $input: ArticleAddInput!
) {
  ArticleAdd(input: $input) {
    articleEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ArticleAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "ArticleAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ArticleAddInput!"
      }
    ],
    "concreteType": "ArticleAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "articleEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "ArticleEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Article",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ArticleAddMutation",
  "id": null,
  "text": "mutation ArticleAddMutation(\n  $input: ArticleAddInput!\n) {\n  ArticleAdd(input: $input) {\n    articleEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ArticleAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ArticleAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2d450945f5937410e1db5c312004d7e5';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/ArticleAddMutation.graphql.js